import React, { useEffect } from "react";
import styles from '../styles/components/HeadwayWidget.module.css';
import AppConfig from '../AppConfig';

declare global {
  interface Window { Headway: any; }
}

const HeadwayWidget: React.FC = () => {
  useEffect( () => {
    let config = {
      selector: "#headway-badge",
      account: AppConfig.headwayAccount
    };
    if (window.Headway) {
      window.Headway.init(config)
    }
  }, [])

  return (
    <div className={styles.headwayBadge} id="headway-badge"/>
  )
}

export default HeadwayWidget;